
  import {defineComponent} from 'vue';
  import InformationComponent from "@/components/shared/InformationComponent.vue";
  import {Item} from "@/domain/ui/Item";
  import api from "@/api/backend-api";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import {mapGetters} from "vuex";
  import store from "@/store";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import router from "@/router";
  export default defineComponent({
    name: 'RefundingHistoryView',
    components: {
      HeaderComponent,
      InformationComponent
    },
    props:['ticketId'],
    data() {
      return {
        titleStatus: "",
        ticketInformation: [] as Array<Item>,
        refundingInformation: [] as Array<Item>,
      }
    },
    computed: {
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    mounted() {
      api.getRefundHistory(this.ticketId)
      .then(response => {
        console.log(response);
        if (response.data.code === 4444) {
          if (store.getters['AppYnStore/isApp']) {
            router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
          } else {
            store.commit('NextViewStore/setNextView', new NamedRouting('RefundingHistoryView', {orderId: this.ticketId}));
            router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
          }
          return;
        }

        const refundHistory = response.data.result;
        this.ticketInformation.push(new Item('사용처', refundHistory.brandName));
        this.ticketInformation.push(new Item('수량', '1개'));
        this.ticketInformation.push(new Item('유효기간', refundHistory.validityStartDate + ' ~ ' + refundHistory.validityEndDate));
        this.ticketInformation.push(new Item('주문번호', refundHistory.orderId));
        this.ticketInformation.push(new Item(refundHistory.contactUs, refundHistory.contactUsTel, true));

        this.refundingInformation.push(new Item('환불 신청일', refundHistory.refundRequestDate));

        switch (refundHistory.refundStatus) {
          case "REFUNDING":
            this.titleStatus = "대기";
            this.refundingInformation.push(new Item('환불 상태', '환불 대기중', false, true));
            break;
          case "REFUND_FAIL":
            this.titleStatus = "실패";
            this.refundingInformation.push(new Item('환불 상태', '환불 실패', false, true));
            break;
          case "REFUNDED":
            this.titleStatus = "완료";
            this.refundingInformation.push(new Item('환불 완료일', refundHistory.refundCompleteYmdt));
            break;
        }

        this.refundingInformation.push(new Item('환불 수단', refundHistory.refundType === 'POINT' ? '포인트' : '계좌'));
        this.refundingInformation.push(new Item('환불 금액', refundHistory.refundAmount));
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    }
  });

